var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose-pay"},[_c('b',[_vm._v(_vm._s(_vm.$t("card.pay_method")))]),_c('div',{staticClass:"d-flex pt-15 justify-content-between"},[_c('div',{class:{
        'pay-option': true,
        active: _vm.value == 'cash',
      },on:{"click":function($event){return _vm.$emit('input', 'cash')}}},[_vm._v("\n      "+_vm._s(_vm.$t("pay.by_cash"))+"\n    ")]),_c('div',{class:{
        'pay-option': true,
        active: _vm.value == 'card',
      },on:{"click":function($event){return _vm.$emit('input', 'card')}}},[_vm._v("\n      "+_vm._s(_vm.$t("pay.by_card"))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }